<template>
  <div class="wrapper">
    <div class="course">
      <img style="width: 100%" src="../assets/beast-map.jpg"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Course'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .course {
   height: 100%;
 }

 .course img {
   width: 100%;
   background: white;
   max-width: 800px;
   margin-top: 40px;
 }
</style>
